import React, {useState} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import PerfGateway from "./subPages/PerfGateway";
import PerfRepeater from "./subPages/PerfRepeater";

const PerfCmnctEqpmn = () => {

  const [tab, setTab] = useState('gateway');

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <Container fluid>
          <Row className={"p-3"}>
            <Col md={12}>
              <Row className={"tabs mb-3"}>
                <Col md={12} className={"p-0"}>
                  <Button
                      type={"button"}
                      className={`tab-btn  px-4 me-3 ${tab === 'gateway' ? 'active' : ''}`}
                      onClick={() => setTab('gateway')}
                  >
                    무선게이트웨이
                  </Button>
                  <Button
                      type={"button"}
                      className={`tab-btn  px-4 me-3 ${tab === 'repeater' ? 'active' : ''}`}
                      onClick={() => setTab('repeater')}
                  >
                    무선중계기
                  </Button>
                </Col>
              </Row>
              <Row className={"pe-0"}>
                {tab === 'gateway' ?
                    (<>
                      <PerfGateway/>
                      {/*<PerfStmCpu/>*/}
                    </>) : ''}
                {tab === 'repeater' ?
                    (<>
                      <PerfRepeater/>
                      {/*<PerfStmMemory/>*/}
                    </>) : ''}
              </Row>
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default PerfCmnctEqpmn;
